import DOMPurify from "dompurify";
import router from "../router.js";
import store from "../store/index.js";
import PurifierSettings from "../configs/DOMPurify/profile.js";

const utility = {
    purify: function(value) {
        const settings = PurifierSettings;
        
        return DOMPurify.sanitize(value, settings);
    },
    dateTimeNow: function() {
        const date = new Date().toLocaleDateString("tr-TR");
        const time = new Date().toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });

        return date + " " + time;
    },
    setDatatableLanguage: function (langId, tableId) {
        const datatableLanguage = {
            tableId: "",
            langUrl: ""
        }

        if (langId == "tr") {
            datatableLanguage.tableId = tableId + "Tr";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/tr.json";
        } else if (langId == "en") {
            datatableLanguage.tableId = tableId + "En";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/en-GB.json";
        } else if (langId == "ar") {
            datatableLanguage.tableId = tableId + "Ar";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/ar.json";
        } else if (langId == "bg") {
            datatableLanguage.tableId = tableId + "Bg";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/bg.json";
        } else if (langId == "de") {
            datatableLanguage.tableId = tableId + "De";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/de-DE.json";
        } else if (langId == "es") {
            datatableLanguage.tableId = tableId + "Es";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/es-ES.json";
        } else if (langId == "it") {
            datatableLanguage.tableId = tableId + "It";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/it-IT.json";
        } else if (langId == "ge") {
            datatableLanguage.tableId = tableId + "Ge";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/ka.json";
        } else if (langId == "kz") {
            datatableLanguage.tableId = tableId + "Kz";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/kk.json";
        } else if (langId == "sr") {
            datatableLanguage.tableId = tableId + "Sr";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/sr.json";
        } else if (langId == "nl") {
            datatableLanguage.tableId = tableId + "Nl";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/nl-NL.json";
        } else if (langId == "ro") {
            datatableLanguage.tableId = tableId + "Ro";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/ro.json";
        } else if (langId == "ru") {
            datatableLanguage.tableId = tableId + "Ru";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/ru.json";
        } else if (langId == "uk") {
            datatableLanguage.tableId = tableId + "Uk";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/uk.json";
        } else {
            datatableLanguage.tableId = tableId + "Unk";
            datatableLanguage.langUrl = "https://cdn.datatables.net/plug-ins/2.1.8/i18n/tr.json";
        }

        return datatableLanguage;
    },
    trimUrl: function (url) {
        if (url && url.length != 0) {
            var protocolString = /(http(s?)):\/\//i;

            return url.replace(protocolString, "").replace("www.", "");
        }
    },
   dateFormat: function (dateStr) {
        if (!dateStr || dateStr === null || dateStr === undefined) return "-";
        
        if (dateStr.includes("Z")) dateStr = dateStr.replace("Z", "");

        const date = new Date(dateStr);
        
        // Check if date is valid
        if (isNaN(date.getTime())) return "-";
        
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");

        return `${day}.${month}.${year} ${hours}:${minutes}`;
    },
    // Onaylı cevaplamada gönderilmemiş cevabın etiketi; Cevaplar, Arşiv ve Kullanıcı Geçmişi aynı kuralı kullanır.
    // Gönderilmiş ya da onay akışı dışındaki cevapta null döner.
    answerApproveLabelKey: function (isSent, approveStep, isDontTouch) {
        if (isSent) return null;
        if (isDontTouch) return "feedDialogs.archiveDialog.dontTouch";
        if (approveStep == 2) return "feedDialogs.archiveDialog.secondApproveSent";
        if (approveStep == 1) return "feedDialogs.archiveDialog.firstApproveSent";

        return null;
    },
    checkQueryParams: function (paramsObject) {
        const params = new URLSearchParams();

        Object.entries(paramsObject).filter(([key, value]) =>
            (value !== undefined && value !== null && value.length !== 0) &&
            (key !== undefined && key !== null && key.length !== 0)).reduce((acc, [key, value]) => {
                acc[key] = value;

                if (Array.isArray(value)) {
                    value.forEach(keyword => params.append(key.toString(), keyword));
                } else {
                    params.append(key.toString(), value)
                }

                return acc;
            }, {}
        );

        return params;
    },
    fetch: async function (path, method, customHeader, contentBody, skipLoading = false, keepAlive = false) {
        if(!skipLoading) store.dispatch("pageIsLoading", true);        

        let body = null;
        const header = new Headers();
        const isFormData = contentBody instanceof FormData;

        if ((method === "POST" || method === "PUT") && !isFormData) header.append("Content-Type", "application/json");
        
        const userToken = store.getters.token;        

        if (userToken) header.append("Authorization", `Bearer ${userToken}`);

        const workspaceId = store.getters.workspaceIdForHeader;

        if (workspaceId) header.append("WorkspaceId", workspaceId);

        //customerHeader example: [{name: "XSS-Flag", value: "1"}]
        if (customHeader) {
            for (const item of customHeader) {
                header.append(item.name, item.value);
            }
        }

        if (contentBody && (method === "POST" || method === "PUT")) body = isFormData ? contentBody : JSON.stringify(contentBody);
        
        let response;

        try {
            response = await fetch(`${process.env.VUE_APP_SNIFFER_API}/${path}`, {
                method: method,
                headers: header,
                body: body,
                keepalive: keepAlive
            });
        } catch (networkError) {
            if (!skipLoading) store.dispatch("pageIsLoading", false);

            throw networkError;
        }

        if (!response.ok) {
            // Gövde JSON değilse (ör. IIS'in HTML hata sayfası) json() fırlatır; yükleme sayacı takılı kalmasın.
            var customError = await this.generateErrorMessage(response).catch(() => "");

            const error = new Error();

            if (customError && typeof customError === "object") {
                error.message = customError.message;
                error.cause = customError.statusCode;
            }

            if (response.status == 401) {
                const userLoggedIn = store.getters.isAuthenticated;
                
                if (userLoggedIn) store.dispatch("autoLogout", { reason: "api-401", endpoint: path.split("?")[0], serverMessage: error.message });

                if (!skipLoading) store.dispatch("pageIsLoading", false);

                throw error;
            } else if (response.status == 403) {
                router.replace("/unauthorized");
                if (!skipLoading) store.dispatch("pageIsLoading", false);

                throw error;
            } else if (response.status == 404) {
                router.replace("/notFound");
                if (!skipLoading) store.dispatch("pageIsLoading", false);

                throw error;
            }
        
            if (!skipLoading) store.dispatch("pageIsLoading", false);
     
            throw error;
        } else if (response.status == 204) {
            if (!skipLoading) store.dispatch("pageIsLoading", false);
            
            return "";
        }
        
        if (!skipLoading) store.dispatch("pageIsLoading", false); 

        if (response.headers.get("Content-Type")?.includes("application/json")){
            const responseData = await response.json();

            return responseData;            
        } else {
            const fileData = await response.blob();
            const disposition = response.headers.get("Content-Disposition") || response.headers.get("content-disposition");
            let fileName = "File";

            if (disposition) {
                const fileNameMatch = disposition?.match(/filename="?([^"]+)"?/);

                fileName = fileNameMatch?.[1];
            } else {
                if (response.headers.get("Content-Type")?.includes("application/vnd.ms-excel")) fileName = "File.xls";
            }
            
            const url = window.URL.createObjectURL(fileData);
            const link = document.createElement("a");

            link.href = url;
            link.download = fileName;
            link.click();

            window.URL.revokeObjectURL(url);            
        }
    },
    sourceName: function(sourceId) {
        return sourceId == 1 ? "TWITTER" : sourceId == 2 ? "FACEBOOK" : sourceId == 5 ? "SIKAYETVARCOM" : sourceId == 11 ? "YOUTUBE" : sourceId == 20 ? "INSTAGRAM" : sourceId == 23 ? "LINKEDIN" : sourceId == 24 ? "GOOGLEPLAY" : sourceId == 27 ? "RPA" : sourceId == 28 ? "TIKTOK" : "";
    },
    sourceNameQueryParameter: function(sourceId) {
        return sourceId == 1 ? "TwitterKurumsal=" : sourceId == 2 ? "Facebook=" : sourceId == 20 ? "Instagram=" : sourceId == 23 ? "Linkedin=" : sourceId == 11 ? "Youtube=" : "";
    },
    convertUnicode(unicode) {
        unicode = unicode.replace(/[Uu]\+10([A-Fa-f0-9]{4})/g, (_, offset) => {
            return this.convertHex("10" + offset);
        });

        unicode = unicode.replace(/[Uu]\+([A-Fa-f0-9]{1,5})/g, (_, offset) => {
            return this.convertHex(offset);
        });

        return unicode;
    },
    convertHex(hexCode) {
        let char = "";
        let length = parseInt(hexCode, 16);

        if (length <= 0xFFFF) {
            char += String.fromCharCode(length);
        } else if (length <= 0x10FFFF) {
            length -= 0x10000;

            char += String.fromCharCode(0xD800 | (length >> 10)) + String.fromCharCode(0xDC00 | (length & 0x3FF));
        }

        return char;
    },
    generateErrorMessage: async function (errorResponse) {
        const errorResponseData = await errorResponse.json();
   
        if (errorResponseData && errorResponseData.traceId) {
            const errorDetailMessage = errorResponseData.statusCode == 400 ? `${errorResponseData.error.detail} (${errorResponseData.traceId})` : `Beklenmedik bir hata oluştu. Lütfen daha sonra tekrar deneyiniz. (${errorResponseData.traceId})`;

            const customError = {
                message: errorDetailMessage,
                statusCode: errorResponseData.statusCode
            };

            return customError;
        }

        return "";
    },
    getDataTablePaginationParams: function (dataTablesParams) {
        const { start, length, search, order, columns } = dataTablesParams;
        const defaultOrderColumn = columns[0]?.data || '';
        const defaultOrderDir = 'desc';
   
        return {
            pageNumber: Math.floor(start / length) + 1,
            pageSize: length,
            orderColumn: order?.[0]?.column !== undefined ? columns[order[0].column]?.data || defaultOrderColumn : defaultOrderColumn,
            orderDir: order?.[0]?.dir || defaultOrderDir,
            searchText: search?.value || '',
      };
    },
    selectAllFormat: function (data, selectAllCallback, deselectAllCallback) {
        if (data.id === "-1" || data.id === "-2") {
            const container = document.createElement('div');
            container.style.display = 'flex';
            container.style.gap = '50px';
            container.style.justifyContent = 'space-between';
            container.style.alignItems = 'center';
            container.style.padding = '8px 12px';
            container.classList.add("helper_buttons");
            container.style.setProperty('background-color', 'white', 'important');
   
            const selectAllButton = document.createElement('button');
            selectAllButton.textContent = 'Hepsini Seç';
            selectAllButton.type = 'button';
            selectAllButton.style.backgroundColor = '#6c757d';
            selectAllButton.style.color = 'white';
            selectAllButton.style.border = 'none';
            selectAllButton.style.borderRadius = '4px';
            selectAllButton.style.padding = '6px 12px';
            selectAllButton.style.cursor = 'pointer';
        
            const deselectAllButton = document.createElement('button');
            deselectAllButton.textContent = 'Seçimi Kaldır';
            deselectAllButton.type = 'button';
            deselectAllButton.style.backgroundColor = '#6c757d';
            deselectAllButton.style.color = 'white';
            deselectAllButton.style.border = 'none';
            deselectAllButton.style.borderRadius = '4px';
            deselectAllButton.style.padding = '6px 12px';
            deselectAllButton.style.cursor = 'pointer';
   
            selectAllButton.addEventListener('click', (e) => {
                e.stopPropagation();

                selectAllCallback();
            });
   
            deselectAllButton.addEventListener('click', (e) => {
                e.stopPropagation();

                deselectAllCallback();
            });
   
            container.appendChild(selectAllButton);
            container.appendChild(deselectAllButton);

            return container;
        }
        
        return document.createTextNode(data.text);
    },
    updateSelectSummary(wrapperRef) {
        if (!wrapperRef) return;
    
        const wrapper = wrapperRef?.$el?.parentElement;
        const rendered = wrapper?.querySelector(".select2-selection__rendered");

        if (!wrapper || !rendered) return;
    
        const selectedItems = rendered?.querySelectorAll(".select2-selection__choice");
        const selectedCount = selectedItems?.length || 0;
    
        const rendereClientWidth = rendered.clientWidth;
    
        wrapper.classList.remove("has-summary");
        rendered.removeAttribute("data-summary");
    
        let totalWidth = 50;

        selectedItems.forEach((item) => {
            totalWidth += item.offsetWidth;
        });
    
        const isOverflowingWidth = totalWidth > rendereClientWidth;

        if (isOverflowingWidth) {
          wrapper.classList.add("has-summary");

          rendered.setAttribute("data-summary", `${selectedCount} items selected`);
        } else {
          wrapper.classList.remove("has-summary");

          rendered.removeAttribute("data-summary");
        }
    },
    openCenteredWindow(pageURL, title, width = 800, height = 500) {
        const left = (screen.width / 2) - (width / 2);
        const top = (screen.height / 2) - (height / 2);

        return window.open(pageURL, title, `width=${width}, height=${height}, top=${top}, left=${left}`);
    },
    getQueryParams(payload){
        const queryParams = Object.keys(payload).filter(key => {
            const value = payload[key];            
            return value !== undefined && value !== null && (!Array.isArray(value) || value.length > 0);
        }).map(key => {
            const value = payload[key];

            if (Array.isArray(value)) return value.map(item => `${key}=${encodeURIComponent(item)}`).join('&');

            return `${key}=${encodeURIComponent(value)}`;
        }).join('&');

        return queryParams;
    },
    isAllGrantedPermission(permissionList) {
        if (store.getters && Array.isArray(store.getters.uiPermissions) && Array.isArray(permissionList)) {
            const hasSuperUserCheck = permissionList.includes("SuperUserCheck");
            const filteredList = permissionList.filter(p => p !== "SuperUserCheck");
            const superUserOk = hasSuperUserCheck ? utility.isSuperUser() : true;
            const permsOk = filteredList.every(p => store.getters.uiPermissions.includes(p));

            return superUserOk && permsOk;
        }

      return false;
    },
    isAnyGrantedPermission(permissionList) {
        if (store.getters && Array.isArray(store.getters.uiPermissions) && Array.isArray(permissionList)) {
            if (permissionList.includes("SuperUserCheck") && utility.isSuperUser()) return true;
        
            return permissionList.some(p => p !== "SuperUserCheck" && store.getters.uiPermissions.includes(p));
        }

        return false;
    },
    isGrantedPermission(permissionName) {
        if (permissionName === "SuperUserCheck") return utility.isSuperUser();

        if (store.getters && store.getters.uiPermissions) return store.getters.uiPermissions.includes(permissionName);
            
        else return false;
    },
    isSuperUser() {
        if (store.getters && typeof store.getters.isSuperUser !== "undefined" && store.getters.isSuperUser !== null) return store.getters.isSuperUser;

        return false;
    },
    isAvailableSource(sourceName) {
        if (store.getters && store.getters.activeWorkspaceSources) return store.getters.activeWorkspaceSources.includes(sourceName.toUpperCase());

        return false;
    },
    isInternalUser(username) {
        const domainNames = ["global-bilgi", "turkcell"];

        var comparisonRegex = new RegExp(domainNames.join("|"), "i");

        return comparisonRegex.test(username);
    },
    insertBlankChar(str, n = 30) {
        if (n <= 0) return str; 
        let result = '';

        for (let i = 0; i < str.length; i++) {
            result += str[i];
            
            if ((i + 1) % n === 0 && i !== str.length - 1) {
                result += ' ';
            }
        }

        return result;
    }    
};

var accountRelatedPaths = [
    "/login",
    "/validate-otp",
    "/reset-password"
];

export default { utility, accountRelatedPaths };